// components/Chatbot/SmartQuestionsSection.tsx
import { ChevronRight, Loader2 } from 'lucide-react';

export interface SmartQuestionsSectionProps {
  questions: string[];
  onQuestionSelect: (question: string) => void;
  isEmptyState?: boolean;
  loading?: boolean;
}

const SmartQuestionsSection = ({
  questions,
  onQuestionSelect,
  isEmptyState = false,
  loading = false,
}: SmartQuestionsSectionProps) => {
  return (
    <div
      className={`bg-white rounded-lg ${isEmptyState ? '' : 'border border-gray-200 shadow-sm mb-4'} p-4`}
    >
      <div className="flex items-center justify-between mb-4">
        <div>
          <h3
            className={`font-semibold text-gray-900 ${isEmptyState ? 'text-base' : 'text-sm'}`}
          >
            Suggested Questions
          </h3>
          <p className={`text-gray-500 mt-1 ${isEmptyState ? 'text-sm' : 'text-xs'}`}>
            Personalized to your academic plan
          </p>
        </div>
      </div>

      <div className="space-y-2">
        {loading ? (
          <>
            {[1, 2, 3].map((i) => (
              <div
                key={i}
                className="w-full px-3 py-2 rounded-lg border border-gray-200 bg-gray-50 animate-pulse"
              >
                <div className="flex items-center gap-2">
                  <Loader2 className="w-3 h-3 text-gray-400 animate-spin" />
                  <div className="h-4 bg-gray-200 rounded w-3/4"></div>
                </div>
              </div>
            ))}
          </>
        ) : (
          questions.map((question, index) => (
            <button
              key={index}
              onClick={() => onQuestionSelect(question)}
              className={`w-full text-left px-3 py-2 ${isEmptyState ? 'text-sm' : 'text-sm'} rounded-lg border transition-all duration-200 transform hover:scale-[1.02] active:scale-[0.98] bg-primary/10 text-primary-700 dark:text-primary-300 border-primary/20 hover:bg-primary/15 group`}
            >
              <div className="flex items-center justify-between">
                <span className="flex-1 pr-2 break-words">{question}</span>
                <ChevronRight className="w-3 h-3 opacity-0 group-hover:opacity-100 transition-opacity duration-200 text-current" />
              </div>
            </button>
          ))
        )}
      </div>
    </div>
  );
};

export default SmartQuestionsSection;
